import { useContext } from 'react';
import VehicleContext, {
  useGetIsWIPVehicle
} from '~/context/vdp/VehicleContext';
import useShowVaultWhyBuyContent from './useHasVaultWhyBuyData';

export default function useShowWhyBuyContent(): boolean {
  const isWIPVehicle = useGetIsWIPVehicle();
  const {
    ymmtWhyBuy: { data, isLoaded, hasError }
  } = useContext(VehicleContext);
  const vaultWhyBuyContentExists = useShowVaultWhyBuyContent();

  if (isWIPVehicle) return false;

  const ymmtWhyBuyContentExists =
    isLoaded &&
    !hasError &&
    Boolean(data?.summary) &&
    Array.isArray(data?.bulletPoints) &&
    data.bulletPoints.length > 0;

  return vaultWhyBuyContentExists || ymmtWhyBuyContentExists;
}
